import script from "./CustomerSectionCounts.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerSectionCounts.vue?vue&type=script&setup=true&lang=js"

import "./CustomerSectionCounts.vue?vue&type=style&index=0&id=646b7bfc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-646b7bfc"]])

export default __exports__